import React from "react";
import "./Our_Craftmenship.css";
import { useNavigate } from "react-router-dom";

function Our_Craftmenship({ btnText, title, description }) {
  const navigate = useNavigate();
  return (
    <>
      <section className="Your_Idea">
        <div className="custom_container">
          <div className="row align-items-end">
            <div className="col-md-8">
              <div className="text_holder">
                <h1>
                  <span>Your Idea, </span> Our Craftsmanship
                </h1>
                <p>
                  With our Bespoke Gifting service, you can create gifts exactly
                  the way you imagine, From personalised designs to custom
                  messages and special touches, we bring your ideas to life.
                  Make every gift truly unique and unforgettable
                </p>
              </div>
            </div>

            <div className="col-md-4">
              {/* <div className="btn_holder">
                <Purple_Btn
                  btnText={btnText}
                  onClick={() => navigate("/luxury/bespock-gift")}
                />
              </div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Our_Craftmenship;
